import { render, staticRenderFns } from "./BasicFieldInfo.vue?vue&type=template&id=346e670d&scoped=true&lang=html&"
import script from "./BasicFieldInfo.vue?vue&type=script&lang=js&"
export * from "./BasicFieldInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicFieldInfo.vue?vue&type=style&index=0&id=346e670d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346e670d",
  null
  
)

export default component.exports